module.exports = __webpack_public_path__ + "img/troll_warlord.dabd235b.png";